import React from 'react';
import { Box, Typography } from '@mui/material';
import { useUser } from './WebSocketContext';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import { useTranslation } from 'react-i18next';

const HomeDenied = () => {
    const { username } = useUser();
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100%',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <style>
                {`
          @keyframes wave {
            0% { transform: rotate(0deg); }
            10% { transform: rotate(14deg); }
            20% { transform: rotate(-8deg); }
            30% { transform: rotate(14deg); }
            40% { transform: rotate(-4deg); }
            50% { transform: rotate(10deg); }
            60% { transform: rotate(0deg); }
            100% { transform: rotate(0deg); }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-20px);
            }
          }

          @keyframes glow {
            0%, 100% {
              text-shadow: 0 0 20px rgba(255, 255, 255, 0.5),
                           0 0 30px rgba(255, 255, 255, 0.3),
                           0 0 40px rgba(255, 255, 255, 0.2);
            }
            50% {
              text-shadow: 0 0 30px rgba(255, 255, 255, 0.8),
                           0 0 40px rgba(255, 255, 255, 0.5),
                           0 0 50px rgba(255, 255, 255, 0.3);
            }
          }

          @keyframes pulse {
            0%, 100% {
              transform: scale(1);
              opacity: 0.3;
            }
            50% {
              transform: scale(1.5);
              opacity: 0;
            }
          }
        `}
            </style>

            {/* Animated background circles */}
            <Box
                sx={{
                    position: 'absolute',
                    top: '20%',
                    left: '10%',
                    width: '300px',
                    height: '300px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.1)',
                    animation: 'float 6s ease-in-out infinite',
                }}
            />
            <Box
                sx={{
                    position: 'absolute',
                    bottom: '10%',
                    right: '15%',
                    width: '200px',
                    height: '200px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.1)',
                    animation: 'float 8s ease-in-out infinite reverse',
                }}
            />

            {/* Pulsing circle behind icon */}
            <Box
                sx={{
                    position: 'absolute',
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    background: 'rgba(255, 255, 255, 0.3)',
                    animation: 'pulse 2s ease-in-out infinite',
                }}
            />

            {/* Waving hand icon */}
            <WavingHandIcon
                sx={{
                    fontSize: '80px',
                    color: '#FFD700',
                    mb: 3,
                    animation: 'wave 2s ease-in-out infinite, fadeInUp 0.8s ease-out',
                    filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2))',
                    zIndex: 1,
                }}
              aria-label={t('homeDenied.waveIconAria')}
            />

            {/* Hello message */}
            <Typography
                variant="h2"
                sx={{
                    color: 'white',
                    fontWeight: 700,
                    mb: 2,
                    animation: 'fadeInUp 0.8s ease-out 0.2s both, glow 3s ease-in-out infinite',
                    textAlign: 'center',
                    fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4rem' },
                    zIndex: 1,
                }}
            >
                {t('homeDenied.hello', { username })}
            </Typography>

            {/* Subtitle */}
            <Typography
                variant="h5"
                sx={{
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontWeight: 400,
                    animation: 'fadeInUp 0.8s ease-out 0.4s both',
                    textAlign: 'center',
                    maxWidth: '600px',
                    px: 3,
                    fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
                    zIndex: 1,
                }}
            >
                {t('homeDenied.subtitle')}
            </Typography>
        </Box>
    );
};

export default HomeDenied;
